import { slideDown, slideUp } from '@/modules/functions';

export class Accordion {
  accordionItem;
  constructor() {}

  init() {
    this.accordionItem = document.querySelectorAll('.accordion-item');
    if (!this.accordionItem || this.accordionItem.length === 0) return;

    this.accordionItem.forEach((el) => {
      const head = el.querySelector('.accordion-item-head');
      const body = el.querySelector('.accordion-item-body');
      head.addEventListener('click', () => {
        if (head.classList.contains('active')) {
          head.classList.remove('active');
          slideUp(body, 300);
        } else {
          head.classList.add('active');
          slideDown(body, 300);
        }
      });
    });
  }
}
